(ns app.front.view.agreement.list
  (:require [app.domain.attachment.file-formats :as file-formats]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.workspace.section :as ws-section]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::date-update-success
  (fn [{:keys [db]} [_ agreement-id status db-changes]]
    {:dispatch-n [[::entities/apply-changes status db-changes]
                  [:notifications/add
                   :toast
                   :success
                   :success
                   :agreement/date-updated]]
     :db         (update db ::agreements dissoc agreement-id)}))


(rf/reg-sub
  ::agreement-edited?
  (fn [db [_ agreement-id]]
    (get-in db [::agreements agreement-id])))


(rf/reg-sub
  ::agreement-edited-date
  (fn [db [_ agreement-id]]
    (get-in db [::agreements agreement-id :agreement-date])))


(rf/reg-event-db
  ::save-agreement-date
  (fn [db [_ agreement-id date]]
    (assoc-in db [::agreements agreement-id :agreement-date] date)))


(rf/reg-event-fx
  ::save-agreement
  (fn [{:keys [db]} [_ application agreement-id]]
    (let [date (get-in db [::agreements agreement-id :agreement-date])]
      {:dispatch [:app.front.process/signal
                  application
                  [:process.signal/save-agreement-date {:agreement-id   agreement-id
                                                        :agreement-date date}]
                  {:on-success [::date-update-success agreement-id]}]})))


(rf/reg-event-fx
  ::delete-agreement
  (fn [_ [_ application agreement-id]]
    {:dispatch [:app.front.process/signal
                application
                [:process.signal/delete-agreement {:agreement-id agreement-id}]
                {:notify {:success :agreement/delete-success}}]}))


(defn upload-button [on-attach]
  [upload/upload-button
   "upload-agreement"
   {:attach-file-fn  on-attach
    :button-i18n-key :agreement/upload-help
    :accept-types    file-formats/convertable-accept-value-for-input}])


(defn- add-agreement-attachment [application file-id filename content-type md5]
  (>evt [:app.front.process/signal
         application
         [:process.signal/add-agreement-file
          {:file-id           file-id
           :file/filename     filename
           :file/content-type content-type
           :file/category     :file.category/agreement
           :file/md5          md5}]
         {:notify {:success :agreement/upload-success}}]))


(defn list-view [{:keys [application tr] :as state}]
  (let [authority? (<sub [:app.front.process/app-signal-permitted?
                          [:process.signal/add-agreement-file]])
        agreements (<sub [::entities/entities {:entity/type   :entity.type/agreement
                                               :entity/parent (:db/id application)}])]
    (when (or authority?
              (seq agreements))
      [ws-section/section
       application
       :agreement/agreement
       state
       :agreement/agreement
       true
       (when (seq agreements)
         #_{:clj-kondo/ignore [:deprecated-var]}
         [ui-table/responsive-table {:tr          tr
                                     :class       "mb-4"
                                     :expandable? false}
          (remove nil?
                  [{:title (tr [:agreement/filename])}
                   {:title (tr [:agreement/added])}
                   {:title (tr [:agreement/agreement-date])}
                   (when authority? {:title ""})])
          (futil/for-all [agreement agreements]
            (let [file         (-> (eu/descendants :entity.type/file agreement)
                                   (p/find-first {:file/category :file.category/agreement}))
                  agreement-id (:db/id agreement)]
              {:key  agreement-id
               :cols [{:opts    {:class "bold overflow-hidden"}
                       :content (when file
                                  [file-download/download-workspace-file-link file
                                   {:class "break-words"
                                    :text  (:file/filename file)}])}
                      {:content (str ((<sub [::date-util/date-time-fn]) (:entity/created agreement))
                                     " by " (user-model/full-name (:entity/creator agreement)))}
                      {:content (if authority?
                                  [ui/date-picker {:value    (:agreement/agreement-date agreement)
                                                   :width    "100%"
                                                   :callback #(>evt [::save-agreement-date agreement-id %])}]
                                  ((<sub [::date-util/date-fn]) (:agreement/agreement-date agreement)))}
                      (when authority?
                        {:opts    {:class "text-right"}
                         :content [:<>
                                   (cc/button {:kind       :primary
                                               :class-name "pr-4"
                                               :disabled   (or (not (<sub [::agreement-edited? agreement-id]))
                                                               (nil? (<sub [::agreement-edited-date agreement-id])))
                                               :on-click   #(>evt [::save-agreement application agreement-id])}
                                              (tr [:confirm]))
                                   [ui/modal-confirmation-button
                                    {:tr                  tr
                                     :id                  "delete-agreement"
                                     :modal-class         "text-left"
                                     :modal-title         (tr [:agreement/delete-agreement])
                                     :trigger-button-opts {:icon i/trash}
                                     :trigger-button-text (tr [:delete])
                                     :on-yes-click        #(>evt [::delete-agreement application agreement-id])}
                                    (tr [:agreement/delete-confirmation])]]})]}))])
       (when authority?
         [:div.bx--row
          [:div.bx--col-xs-12
           [upload-button (partial add-agreement-attachment application)]]])])))
